// Lightweight DOM-to-PNG using SVG foreignObject (no external dependency).
//
// 关键策略：
// 1) 用 scrollWidth / scrollHeight 代替 getBoundingClientRect，捕获完整内容（含被 overflow 裁掉的部分）
// 2) inlineStyles 用 cssText 把所有 computed 属性灌进 clone，避免漏 flex / position / min-* 等
// 3) 暂时移除 clone 上的 overflow，让所有内容都渲染

function inlineStyles(src, dst) {
  if (!(src instanceof Element)) return;
  const cs = getComputedStyle(src);
  // 用 cssText 把全部 computed style 灌进去
  let css = cs.cssText;
  if (!css) {
    // 某些环境 cssText 为空，回退到 entries 拼接
    const parts = [];
    for (let i = 0; i < cs.length; i++) {
      const k = cs.item(i);
      const v = cs.getPropertyValue(k);
      if (v) parts.push(`${k}:${v}`);
    }
    css = parts.join(';');
  }
  // overflow 不传递（避免 clone 内还裁切）
  css = css.replace(/overflow[^;]*;/g, '').replace(/overflow-[xy][^;]*;/g, '');
  // sticky / fixed 在 SVG foreignObject 里行为异常（会盖在内容上方挡住前几行）
  // 强制改 static，让元素回到 normal flow 位置
  css = css.replace(/position:\s*(sticky|fixed)[^;]*;/g, 'position:static;');
  // 截图用于打印，去掉所有 box-shadow（投影 / 边缘阴影线对印刷无意义且占空间）
  css = css.replace(/box-shadow[^;]*;/g, 'box-shadow:none;');
  // 去掉 backdrop-filter（SVG foreignObject 不支持，且打印不需要磨砂效果）
  css = css.replace(/backdrop-filter[^;]*;/g, '').replace(/-webkit-backdrop-filter[^;]*;/g, '');
  dst.setAttribute('style', css + (dst.getAttribute('style') || ''));
  const sc = src.children, dc = dst.children;
  for (let i = 0; i < sc.length; i++) inlineStyles(sc[i], dc[i]);
}

export async function exportPng(selector, filename = '截图', prepareClone) {
  const node = document.querySelector(selector);
  if (!node) return;
  // 用 scrollWidth/scrollHeight 拿全量内容尺寸（包括被 overflow:auto 裁掉的部分）
  const w = Math.max(node.scrollWidth, node.getBoundingClientRect().width);
  const h = Math.max(node.scrollHeight, node.getBoundingClientRect().height);
  const clone = node.cloneNode(true);
  inlineStyles(node, clone);
  // clone 外层也强制 overflow visible
  clone.style.overflow = 'visible';
  clone.style.width = w + 'px';
  clone.style.height = h + 'px';
  // 调用方可选清理 clone（比如删掉 UI 控件、覆盖某些样式）
  if (typeof prepareClone === 'function') prepareClone(clone);
  const xml = new XMLSerializer().serializeToString(clone);
  const data = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}">
    <foreignObject width="100%" height="100%">
      <div xmlns="http://www.w3.org/1999/xhtml">${xml}</div>
    </foreignObject>
  </svg>`;
  const img = new Image();
  img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(data);
  await new Promise((res, rej) => { img.onload = res; img.onerror = rej; });
  const canvas = document.createElement('canvas');
  canvas.width = w * 2; canvas.height = h * 2;
  const ctx = canvas.getContext('2d');
  ctx.scale(2, 2);
  ctx.fillStyle = getComputedStyle(document.body).backgroundColor;
  ctx.fillRect(0, 0, w, h);
  ctx.drawImage(img, 0, 0);
  canvas.toBlob((blob) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    // 文件名完全由调用方决定，函数不再附加日期；只补 .png 后缀
    a.download = filename.endsWith('.png') ? filename : `${filename}.png`;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
  }, 'image/png');
}
